import { memo } from 'react';

import styled from '@emotion/styled';
import type { Recording } from '../../../types';
import {
  BrowserInfo,
  CountryInfo,
  DeviceInfo,
  OSInfo,
  ReferrerInfo,
  UserIdInfo,
} from '../../SessionInfo';
import { SimilarRecordingsFilterOptions } from '../constants';
import type { SimilarRecordingsFilterOption } from '../types';

const StyledCheckboxLabel = styled.div`
  display: flex;
  align-items: center;
`;

const getFilterComponent = (filter: SimilarRecordingsFilterOption, recording: Recording) => {
  switch (filter) {
    case SimilarRecordingsFilterOptions.COUNTRY:
      return <CountryInfo recording={recording} />;
    case SimilarRecordingsFilterOptions.DEVICE:
      return <DeviceInfo recording={recording} />;
    case SimilarRecordingsFilterOptions.BROWSER:
      return <BrowserInfo recording={recording} />;
    case SimilarRecordingsFilterOptions.OS:
      return <OSInfo recording={recording} />;
    case SimilarRecordingsFilterOptions.REFERRER:
      return <ReferrerInfo recording={recording} />;
    case SimilarRecordingsFilterOptions.USER_ID:
      return <UserIdInfo recording={recording} asLink={false} />;
    default:
      return null;
  }
};

const UnMemoSimilarRecordingsFilterLabel = ({
  filter,
  recording,
}: {
  filter: SimilarRecordingsFilterOption;
  recording: Recording;
}): JSX.Element | null => {
  return (
    <StyledCheckboxLabel data-testid={`similar-recording-filter-${filter.toLowerCase()}`}>
      {getFilterComponent(filter, recording)}
    </StyledCheckboxLabel>
  );
};

export const SimilarRecordingsFilterLabel = memo(UnMemoSimilarRecordingsFilterLabel);
